export default "__VITE_ASSET__Ce7GjSgo__"